
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface PEONeedsProps {
  value: string[];
  onChange: (needs: string[]) => void;
}

export const PEONeeds = ({ value, onChange }: PEONeedsProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="top_3_peo_needs">Priorities in selecting a PEO partner</Label>
      <Input
        id="top_3_peo_needs"
        placeholder="Enter top reasons for seeking a PEO, separated by commas"
        defaultValue={value.join(', ')}
        onChange={(e) => {
          const needs = e.target.value.split(',').map(need => need.trim()).filter(Boolean);
          onChange(needs);
        }}
      />
      <p className="text-sm text-muted-foreground">
        Example: Reduce HR administrative burden, Access better employee benefits, Ensure compliance across multiple states
      </p>
    </div>
  );
};
